export default {
  hubTenants: (state) => state.hubTenants
};
